
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/cookie-policy",
      function () {
        return require("private-next-pages/policy/cookie-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/cookie-policy"])
      });
    }
  